import axios from 'axios'
import createPersist from 'vuex-localstorage' 

const BASE_URL = "http://18.191.187.177:3000"

// initial state
const state = {
  documents: {},
}

const getters = {

}

const mutations = {
  setDocuments (state, documents) {
    console.log(documents)
    state.documents = documents
  },
}

const actions = {
  uploadDocuments(context, Params) {
    console.log(Params)
    var config = {
        headers: {}
    };
    console.log(Params)
    console.log(Params.formData)
    
    return new Promise(function(resolve, reject) {
      axios
        .post(BASE_URL + '/c/uploadDoc', Params, config)
        .then(function (res) {
          (context.commit('activities/setDocuments', res.data, { root: true }))
          resolve(res)
        })
        
    })
    
  },
  verifyDocuments(context, Params) {
    console.log(Params)
    var config = {
        headers: {}
    };
    console.log(Params)
    console.log(Params.formData)
    
    return new Promise(function(resolve, reject) {
      axios
        .post(BASE_URL + '/c/verifyDoc', Params, config)
        .then(function (res) {
          (context.commit('activities/setDocuments', res.data, { root: true }))
          resolve(res)
        })
        
    })
    
  },
}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}